function normalizedTeamPid(teamPid: string | string[]) {
  return Array.isArray(teamPid) ? teamPid[0] : teamPid
}

function normalizedBillingReturnPath(returnPath: string) {
  return returnPath.startsWith('/') && !returnPath.startsWith('//') ? returnPath : '/'
}

export function buildBillingActionUrl(
  backendUrl: string,
  teamPid: string | string[],
  action: 'billing' | 'subscribe' | 'changePlan',
  returnPath: string,
  params: Record<string, string> = {}
) {
  const query = new URLSearchParams(params)
  query.set('redirect', normalizedBillingReturnPath(returnPath))
  return `${backendUrl}/${normalizedTeamPid(teamPid)}/${action}?${query.toString()}`
}

export function buildBillingPortalUrl(
  backendUrl: string,
  teamPid: string | string[],
  returnPath: string
) {
  return buildBillingActionUrl(backendUrl, teamPid, 'billing', returnPath)
}

export function useBillingUrl() {
  const route = useRoute()

  const goToBillingPortal = () => {
    const backendUrl = import.meta.env.VITE_APP_BACKEND_HOST
    const teamPid = route.params.teamPid
    window.location.href = buildBillingPortalUrl(backendUrl, teamPid, route.fullPath)
  }

  return { goToBillingPortal }
}
